var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "logo-a",
    points: "18.615 .076 0 .076 0 32.422 18.615 32.422 18.615 .076"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D02728",
    points: "11.928 16.473 13.915 1.964 27.6 32.422"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "logo-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-a"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D02728",
    points: "18.615 23.851 0 32.422 12.948 .075 8.987 24.18",
    mask: "url(#logo-b)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-mobile.9144cea6.svg";
export { ForwardRef as ReactComponent };